/**
 * The legal markdown sources in docs/ cross-link each other with relative
 * `.md` links so they also resolve on GitHub and the synced public docs
 * site. In-app they render at /legal/<name>, so rewrite those links to the
 * route paths.
 */
export function legalDocHref(href: string): string {
  const match = /^\.\/([\w-]+)\.md$/.exec(href)
  return match ? `/legal/${match[1]}` : href
}
